export default "__VITE_ASSET__ja1TVI35__"